import React from 'react';
import { PatternFormat } from 'react-number-format';

const YearInput = (props, ref) => {
  const { onChange, ...other } = props;
  return (
    <PatternFormat
      {...other} // eslint-disable-line react/jsx-props-no-spreading
      getInputRef={ref}
      format="####"
      onValueChange={(values) => onChange(values.formattedValue)}
    />
  );
};

export default React.forwardRef(YearInput);
